<template>
  <v-data-table
    class="transparent"
    :headers="headers"
    :items="estudios"
  >
    <template #[`item.estatus`]="{ item }">
      <v-chip
        label
        :color="getDocumentStatusColor(item.estatus_c3)"
        class="font-weight-bold"
      >
        {{ getDocumentStatusLabel(item.estatus_c3) }}
      </v-chip>
    </template>
    <template #[`item.acciones`]="{ item }">
      <v-btn
        color="green"
        icon
        @click="updateEstudioStatus(item, true)"
      >
        <v-icon dark>
          mdi-check
        </v-icon>
      </v-btn>
      <v-btn
        color="red"
        icon
        @click="updateEstudioStatus(item, false)"
      >
        <v-icon dark>
          mdi-cancel
        </v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import createPersonaApiRepository from '../../modules/persona/infrastructure/PersonaApiRepository';

export default {
  props: {
    estudios: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      headers: [
        {
          text: 'Institución',
          align: 'start',
          value: 'institucion',
        },
        {
          text: 'Generación',
          align: 'start',
          value: 'generacion',
        },
        {
          text: 'Folio de certificado',
          align: 'start',
          value: 'folio_certificado',
        },
        {
          text: 'Ubicación',
          align: 'start',
          value: 'ubicacion',
        },
        {
          text: 'Última actualización',
          align: 'start',
          value: 'edited_at',
        },
        {
          text: 'Estatus',
          align: 'start',
          value: 'estatus',
        },
        {
          text: '¿Aprobar registro?',
          align: 'center',
          value: 'acciones',
          sortable: false,
        },
      ],
    };
  },

  methods: {
    getDocumentStatusLabel(statusId) {
      if (statusId || statusId === false) {
        return statusId ? 'Aprobado' : 'Rechazado';
      }

      return 'Pendiente de revisión';
    },

    getDocumentStatusColor(statusId) {
      if (statusId || statusId === false) {
        return statusId ? 'success' : 'red';
      }

      return 'grey';
    },

    async updateEstudioStatus(estudio, status) {
      const repository = createPersonaApiRepository();
      const payload = {
        ...estudio,
        estatus_c3: status,
      };
      await repository.updateEstudio(payload);
      const estudioIndex = this.estudios.findIndex((item) => item.id === estudio.id);
      this.estudios[estudioIndex].estatus_c3 = status;
    },
  },
};
</script>
